export const getAddedSetElements = <T>(oldSet: Set<T>, newSet: Set<T>): Set<T> => {
    return new Set(Array.from(newSet).filter(item => !oldSet.has(item)));
};

export const getRemovedSetElements = <T>(oldSet: Set<T>, newSet: Set<T>): Set<T> => {
    return new Set(Array.from(oldSet).filter(item => !newSet.has(item)));
};

export const getSetIntersection = <T>(setA: Set<T>, setB: Set<T>): Set<T> => {
    return new Set(Array.from(setA).filter(item => setB.has(item)));
};

export const getSetDifference = <T>(setA: Set<T>, setB: Set<T>) => {
    return {
        added: getAddedSetElements(setA, setB),
        removed: getRemovedSetElements(setA, setB),
        intersection: getSetIntersection(setA, setB),
    };
};

export const getSetDifferenceAsArray = <T>(setA: Set<T>, setB: Set<T>) => {
    return {
        added: Array.from(getAddedSetElements(setA, setB)),
        removed: Array.from(getRemovedSetElements(setA, setB)),
        intersection: Array.from(getSetIntersection(setA, setB)),
    };
};
